import { Menu, Tooltip } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';

interface ArticleThumbnailProps {
    articleNumber: string;
    thumbnailUri?: string;
}

export const ArticleThumbnail = ({ articleNumber, thumbnailUri }: ArticleThumbnailProps) => {
    const { t } = useTranslation();

    if (!thumbnailUri) {
        return (
            <Tooltip label={t('infoMissingImage')}>
                <Icon icon="image" size="2xl" />
            </Tooltip>
        );
    }

    return (
        <Menu closeDelay={80} openDelay={0} position="left-start" shadow="md" trigger="click-hover" withArrow withinPortal>
            <Menu.Target>
                <button
                    aria-label={`${t('details')} ${articleNumber}`}
                    className="flex h-full w-full items-center justify-center rounded-sm transition-colors hover:bg-background-gray-light"
                    type="button"
                >
                    <img alt={articleNumber} className="h-12 w-12 object-contain" src={thumbnailUri} />
                </button>
            </Menu.Target>

            <Menu.Dropdown className="z-12000 min-w-0 border border-border-ultra-light bg-background-default p-3 shadow-xl">
                <div className="mb-2 text-xs font-semibold font-mono uppercase tracking-wide text-text-light">
                    {articleNumber}
                </div>
                <div className="flex h-52 w-52 items-center justify-center overflow-hidden rounded-md bg-background-gray-ultra-light">
                    <img alt={articleNumber} className="max-h-full max-w-full object-contain" src={thumbnailUri} />
                </div>
            </Menu.Dropdown>
        </Menu>
    );
};
